var map = {
	"./background-blue-bottom.png": [
		92477,
		2477
	],
	"./background-blue.png": [
		44616,
		4616
	],
	"./background-gold.png": [
		40846,
		846
	],
	"./background-homepage.jpg": [
		87779
	],
	"./background-homepage.png": [
		37526,
		7526
	],
	"./bitcoiner/bitcoiner-correct.svg": [
		54852,
		4852
	],
	"./bitcoiner/bitcoiner-wrong.svg": [
		14266,
		4266
	],
	"./bitcoiner/bitcoiner.svg": [
		77609,
		7609
	],
	"./bitcoiner/check.svg": [
		7642,
		7642
	],
	"./bitcoiner/cross.svg": [
		46123,
		6123
	],
	"./btc-support-qr-code.png": [
		71469,
		1469
	],
	"./courses/author-jakub-vejmola.jpg": [
		28407,
		8407
	],
	"./courses/author-stosuj-cz.png": [
		39701,
		9701
	],
	"./courses/bitcoin-do-hloubky.png": [
		97963,
		7963
	],
	"./courses/bitcoin-only-trezory-s-obrazem.jpg": [
		80147,
		147
	],
	"./courses/cashback-saty-historie-vyuziti.png": [
		33539,
		3539
	],
	"./courses/cashback-saty-list.png": [
		46317,
		6317
	],
	"./courses/cashback-saty-souhrn.png": [
		79849,
		9849
	],
	"./courses/cashback-saty-vyuziti.png": [
		83266,
		3266
	],
	"./courses/coinmate-current-maker-fees.png": [
		83051,
		3051
	],
	"./courses/dashboard-strategies-summary.png": [
		22189,
		2189
	],
	"./courses/dca-modes-sell.png": [
		75206,
		5206
	],
	"./courses/dca-sell-limit-settings.png": [
		26138,
		6138
	],
	"./courses/dynamic-dca-backtest-comparison.png": [
		4371,
		4371
	],
	"./courses/dynamic-dca-bot-run.png": [
		77270,
		7270
	],
	"./courses/dynamic-dca-btfd.png": [
		82880,
		2880
	],
	"./courses/dynamic-dca-dashboard.png": [
		28047,
		8047
	],
	"./courses/dynamic-dca-detail-settings.png": [
		85491,
		5491
	],
	"./courses/dynamic-dca-fear-and-greed-chart-july-2024.png": [
		969,
		969
	],
	"./courses/dynamic-dca-fear-and-greed-chart.png": [
		84313,
		4313
	],
	"./courses/dynamic-dca-fear-and-greed-levels.png": [
		60492,
		492
	],
	"./courses/dynamic-dca-fear-and-greed-select.png": [
		81622,
		1622
	],
	"./courses/dynamic-dca-limit-frequency.png": [
		93256,
		3256
	],
	"./courses/dynamic-dca-nupl-advanced-settings.png": [
		27887,
		7887
	],
	"./courses/dynamic-dca-nupl-explanation.png": [
		1676,
		1676
	],
	"./courses/dynamic-dca-nupl-settings.png": [
		22796,
		2796
	],
	"./courses/dynamic-dca-strategy-settings.png": [
		63316,
		3316
	],
	"./courses/dynamic-dca-twitter-poll.png": [
		20637,
		637
	],
	"./courses/dynamic-dca-value-and-multipliers.png": [
		44734,
		4734
	],
	"./courses/exit-calc-1-btc-usd.png": [
		52877,
		2877
	],
	"./courses/exit-calc-btc-czk-300-pct.png": [
		49636,
		9636
	],
	"./courses/exit-calc-btc-czk-50-pct.png": [
		7209,
		7209
	],
	"./courses/grid-backtest-calculations.png": [
		23064,
		3064
	],
	"./courses/grid-backtest.png": [
		13891,
		3891
	],
	"./courses/grid-calculation-balances-overview.png": [
		75945,
		5945
	],
	"./courses/grid-calculation-example.png": [
		93566,
		3566
	],
	"./courses/grid-detail-1.png": [
		54549,
		4549
	],
	"./courses/grid-detail-2.png": [
		51978,
		1978
	],
	"./courses/grid-exchange-chart.png": [
		88878,
		8878
	],
	"./courses/grid-on-dashboard.png": [
		56122,
		6122
	],
	"./courses/grid-price-range.png": [
		19361,
		9361
	],
	"./courses/mesicni-platba-kartou-sleva.png": [
		62233,
		2233
	],
	"./courses/nupl-multipliers-example.png": [
		50362,
		362
	],
	"./courses/recharge-options-supporters.png": [
		57254,
		7254
	],
	"./courses/stosuj-cz-intro-dca-example.png": [
		56776,
		6776
	],
	"./courses/stosuj-cz-intro-grid-example.gif": [
		58718,
		8718
	],
	"./courses/stosuj-cz.png": [
		44280,
		4280
	],
	"./courses/uvod-do-bitcoinu.png": [
		3585,
		3585
	],
	"./dca-home.png": [
		18311,
		8311
	],
	"./dca-strategie.png": [
		61771,
		1771
	],
	"./discord-app.png": [
		93422
	],
	"./dynamic-dca-home.png": [
		37954,
		7954
	],
	"./exit-home.png": [
		36747,
		6747
	],
	"./exit-strategie.png": [
		82768,
		2768
	],
	"./exit-strategy-buy-back-none.svg": [
		85903,
		5903
	],
	"./exit-strategy-buy-back-once.svg": [
		82645,
		2645
	],
	"./exit-strategy-buy-back-repeat.svg": [
		55284,
		5284
	],
	"./grid-example.gif": [
		93424
	],
	"./grid-home.png": [
		35208,
		5208
	],
	"./grid-strategie.png": [
		75317,
		5317
	],
	"./hero-dashboard.png": [
		8542,
		8542
	],
	"./hero-video-poster.png": [
		22802,
		2802
	],
	"./how-it-works.svg": [
		46516,
		6516
	],
	"./lightning-network-support-qr-code.png": [
		76912,
		6912
	],
	"./lightning.png": [
		21868
	],
	"./list-style.png": [
		13906,
		3906
	],
	"./mobile-frame.png": [
		74105,
		4105
	],
	"./partners/bitclub.jpg": [
		15314,
		5314
	],
	"./partners/bitcoin-sfera.png": [
		99503,
		9503
	],
	"./partners/bitcoin-v-kapse.jpg": [
		80840,
		840
	],
	"./partners/bitcoinova-skola.png": [
		53217,
		3217
	],
	"./partners/bitcoinovej-kanal.png": [
		30415,
		415
	],
	"./partners/bitperia.png": [
		65166,
		5166
	],
	"./partners/cas-jsou-penize.png": [
		59144,
		9144
	],
	"./partners/deda-bitcoiner.png": [
		94150,
		4150
	],
	"./partners/kicom.png": [
		23385,
		3385
	],
	"./partners/kryptoguru.png": [
		34626,
		4626
	],
	"./partners/kryptoplebs.png": [
		30255,
		255
	],
	"./partners/ondrej-kobersky.png": [
		70561,
		561
	],
	"./partners/vojta-zizka.png": [
		59237,
		9237
	],
	"./partners/zaujalo-ma.png": [
		4374,
		4374
	],
	"./sats.png": [
		83863
	],
	"./stosuj-tutorial.jpg": [
		41459
	],
	"./stosuj-webinare.jpg": [
		13627
	],
	"./stosuj-youtube.jpg": [
		54590
	],
	"./stripe.png": [
		23288
	],
	"./subscription-pro.png": [
		33321
	],
	"./team/dalibor-fujerik.jpg": [
		68644,
		8644
	],
	"./team/jakub-minarovic.jpg": [
		15311,
		5311
	],
	"./team/lubos-kovarik.png": [
		36350,
		6350
	],
	"./team/lukas-hopp.jpg": [
		84233,
		4233
	],
	"./thepay.png": [
		54234
	],
	"./trezor-devices-perspective.svg": [
		1737,
		1737
	],
	"./trezor-safe-banner.png": [
		383
	],
	"./trezor-safe-models.png": [
		9278
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42358;
module.exports = webpackAsyncContext;